import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function ConfirmDialog({confirm, setConfirm, onConfirm}) {
  return (
    <Dialog
    open={confirm}
    onClose={()=>setConfirm('')}
    aria-labelledby="alert-dialog-title"
    aria-describedby="alert-dialog-description"
    >
        <DialogTitle id="alert-dialog-title">
            {confirm}
        </DialogTitle>
        {/* <DialogContent>
            <DialogContentText id="alert-dialog-description">
            {confirm}
            </DialogContentText>
        </DialogContent> */}
        <DialogActions>
            <Button onClick={()=>setConfirm('')}>Đóng</Button>
            <Button onClick={onConfirm} autoFocus>Xác nhận</Button>
        </DialogActions>
    </Dialog>
  );
}